import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/view/HomeNew'
import Business from '@/view/Business'
import News from '@/view/News'
import AboutUs from '@/view/AboutUs'
import ContactUs from '@/view/ContactUs'
import WaybillQuery from '@/view/WaybillQuery'
import IdCardUpload from '@/view/IdCardUploadCheck'
// import IdCardUploadNew from '@/view/IdCardUploadCOS'
import UserRegistration from '@/view/UserRegistration'
import NewDetail from '@/view/NewDetail'

Vue.use(Router)

export default new Router({
  linkActiveClass: 'router-link-active',
  mode: 'history',
  waitForData: true,
  transitionOnLoad: true,
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: {
        title: "首页_速派快递"
      }
    },
    {
      path: '/Business',
      name: 'Business',
      component: Business,
      meta: {
        title: "产品及服务_速派快递"
      }
    },
    {
      path: '/News',
      name: 'News',
      component: News,
      meta: {
        title: "新闻中心_速派快递"
      }
    },
    {
      path: '/AboutUs',
      name: 'AboutUs',
      component: AboutUs,
      meta: {
        title: "公司概括_速派快递"
      }
    },
    {
      path: '/ContactUs',
      name: 'ContactUs',
      component: ContactUs,
      meta: {
        title: "联系我们_速派快递"
      }
    },
    {
      path: '/WaybillQuery',
      name: 'WaybillQuery',
      component: WaybillQuery,
      meta: {
        title: "运单查询_速派快递"
      }
    },
    {
      path: '/IdCardUpload',
      name: 'IdCardUpload',
      component: IdCardUpload,
      meta: {
        title: "身份证上传_速派快递"
      }
    },
    {
      path: '/UserRegistration',
      name: 'UserRegistration',
      component: UserRegistration,
      meta: {
        title: "用户注册_速派快递"
      }
    },
    {
      path: '/NewDetail',
      name: 'NewDetail',
      component: NewDetail,
      meta: {
        title: "新闻详情_速派快递"
      }
    },
    {
      path: '/PageService',
      name: 'PageService',
      component:()=>import('../view/PageService/PageService'),
      meta: {
        title: "服务_速派快递"
      }
    },
    { // 当没有匹配到正确路由的时候，匹配notOpen组件
      path: '*',
      redirect: '/',
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js